import React, { useEffect } from "react";
import {graphql} from "gatsby";
import {GatsbyImage} from "gatsby-plugin-image";
import styled from "styled-components";
import PageLayout from "@acc-monorepo/gatsby-stories-acc/v2/layout/school/PageLayout";
import {Container, Section} from "@acc-monorepo/gatsby-stories/v2/styles/shared";
import HeadSeo from "@acc-monorepo/gatsby-stories/seo/HeadSeo";
import HeadingWithBackground from "@acc-monorepo/gatsby-stories-acc/v2/sections/HeadingWithBackground";
import {useSiteMetadata} from "@acc-monorepo/gatsby-stories/seo/use-site-metadata";
import ImageRowSection from "@acc-monorepo/gatsby-stories-acc/v2/sections/ImageRowSection";
import { trackOnce } from '@acc-monorepo/gatsby-stories/utils/zaraz-tracker.js';


const SpacedSection = styled(Section)`
  padding: 3rem 0;
  @media (min-width: 768px) {
    padding: 6rem 0;
  }
`

function CampusTourThankyouPage(props) {
  const {data} = props;
  const {social} = useSiteMetadata();

  useEffect(() => {
    trackOnce('CompleteRegistration', {
      conversion_type: 'CompleteRegistration'
    }).then(result => {
      if (result.success) {
        console.log('CompleteRegistration event tracked:', result.eventId);
      }
    }).catch(error => {
      console.error('CompleteRegistration tracking failed:', error);
    });
  }, []);

  return (
    <PageLayout
      burgerFilling="white"
      logoColor="white"
      headerOverlaysContent
      className="bg-secondary"
    >
      <HeadingWithBackground
        backgroundImage={data.featureImage.childImageSharp.gatsbyImageData}
        objectPosition="50% 60%"
        style={{marginBottom: "1rem"}}
      >
        <h1>Thank You</h1>
      </HeadingWithBackground>
      <SpacedSection>
        <Container>
          <p>
            Thank you for registering for a Principal's Tour. We look forward to welcoming you to our campus!
          </p>
          <p>
            In the mean time, want a sneak peek into school life at ACC Marsden Park? Check out our <a href={social.facebookUrl} target="_blank" rel="noopener noreferrer">Facebook page</a> for the latest school news.
          </p>
        </Container>
      </SpacedSection>
      <ImageRowSection style={{padding: 0}}>
        <GatsbyImage image={data.rowImage1.childImageSharp.gatsbyImageData} alt="Three kindy students"/>
        <GatsbyImage image={data.rowImage2.childImageSharp.gatsbyImageData} alt="Primary student in garden"/>
        <GatsbyImage image={data.rowImage3.childImageSharp.gatsbyImageData} alt="High school volleyball"/>
      </ImageRowSection>
    </PageLayout>
  )
}

export default CampusTourThankyouPage

export function Head() {
  return (
    <HeadSeo
      title="Principal's Tour Registration Confirmation"
      meta={[{name: "robots", content: "noindex, nofollow"}]}
    />
  )
}

export const query = graphql`
  query {
    featureImage: file(relativePath: {eq: "images/thankyou-feature.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          formats: [AUTO, WEBP, AVIF]
          placeholder: BLURRED
          quality: 95
        )
      }
      publicURL
    }
    rowImage1: file(relativePath: {eq: "on-campus/kindy/three-kindy-students.jpg"}) {
      ...RowImage
    }
    rowImage2: file(relativePath: {eq: "on-campus/primary/primary-flowers.jpg"}) {
      ...RowImage
    }
    rowImage3: file(relativePath: {eq: "on-campus/secondary/secondary-volleyball.jpg"}) {
      ...RowImage
    }
  }
`
